export const INSURERS = [
  'NONE',
  'ACA',
  'AHM',
  'AU',
  'BUPA',
  'CBHS',
  'Central West Health Cover',
  'Cessnock Dist Health Benf Fund',
  'Credicare',
  'Defence Health Benefits',
  'Doctors',
  'GMF',
  'GMHBA',
  'Grand United',
  'HBA',
  'HBF',
  'HCF',
  'Health.com',
  'Health Care Insurance',
  'Health Partners',
  'HIF',
  'Latrobe',
  'MBF',
  'Medibank',
  'Mildura District Hospital Fund',
  'MU',
  'Mutal Communities',
  'Mutal Health',
  'Navy Health',
  'NIB',
  'Peoplecare',
  'Phoenix Health Fund',
  'Police Health',
  'Reserve Bank Health Fund',
  'RT',
  'RTA',
  'SGIO',
  'St Lukes',
  'Teachers',
  'Transport Health',
  'Westfund',
  'Queensland Country Health',
  'Frank'
]

export const INDUSTRY = [
  {
    value: 'health_provider',
    label: 'Health Provider'
  },
  {
    value: 'financial_advisor',
    label: 'Financial Advisor'
  },
  {
    value: 'other',
    label: 'Other'
  }
]

export const SERVICES = {
  health_provider: [
    {
      label: 'Alternative Therapy',
      value: 'alternative_theraphy'
    },
    {
      label: 'Chiro',
      value: 'chiro'
    },
    {
      label: 'Dental',
      value: 'dental'
    },
    {
      label: 'Fitness',
      value: 'fitness'
    },
    {
      label: 'Nutrition',
      value: 'nutrition'
    },
    {
      label: 'Optical',
      value: 'optical'
    },
    {
      label: 'Osteo',
      value: 'osteo'
    },
    {
      label: 'Physio',
      value: 'physio'
    },
    {
      label: 'Psychology',
      value: 'psychology'
    },
    {
      label: 'Podiatry',
      value: 'podiatry'
    },
    {
      label: 'Practice Manager',
      value: 'practice_manager'
    }
  ],
  financial_advisor: [
    {
      value: 'aggregator',
      label: 'Aggregator'
    },
    {
      value: 'book_keeper',
      label: 'Book Keeper'
    },
    {
      value: 'financial_advisor',
      label: 'Financial Advisor'
    },
    {
      value: 'mortgage_broker',
      label: 'Mortgage Broker'
    },
    {
      value: 'risk_advisor',
      label: 'Risk Advisor'
    },
    {
      value: 'tax_agent',
      label: 'Tax Agent'
    }
  ],
  other: [
    {
      value: 'others',
      label: 'Other'
    }
  ]
}

export const COLLECT_REFERRAL = [
  'Yes',
  'No',
  'Undecided'
]
